export const Dimensions = {
    maxUIWidth: 1280,
    navBarHeight: 100,
    footerHeight: 250,
    padding: 15
};
